import { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { HeroInlineQuotes } from "../components/HeroInlineQuotes";
import { LiveActivityFeed, LiveShoppersBar } from "../components/LiveActivityFeed";
import { ProductGrid } from "../components/ProductGrid";
import { BundleOffer } from "../components/BundleOffer";
import { WhySection } from "../components/WhySection";
import { Testimonials } from "../components/Testimonials";
import { FoundersBanner } from "../components/FoundersBanner";
import { FAQ } from "../components/FAQ";
import { Footer } from "../components/Footer";
import ProductSchema from "../components/ProductSchema";
import { api } from "../lib/api";

export default function LandingPage() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Always request USD for schema price stability (Google won't see currency switcher state).
    api
      .get("/products?currency=USD")
      .then((r) => setProducts(r.data?.products || []))
      .catch(() => setProducts([]));
  }, []);

  return (
    <div data-testid="landing-page">
      <ProductSchema products={products} />
      <Header />
      <LiveShoppersBar />
      <Hero />
      <HeroInlineQuotes />
      <ProductGrid />
      <BundleOffer />
      <WhySection />
      <Testimonials />
      <FoundersBanner />
      <FAQ />
      <Footer />
      <LiveActivityFeed />
    </div>
  );
}
